import React, { useEffect, useState } from "react";
import {
  Button,
  FormFieldSet,
  ToolTip,
  useFormHandler,
} from "../../../../../../../components";
import { filterEmptyValues } from "../../../../../../../utils/filterEmptyValues";
import { addNewPlacementStart } from "../../../../../../../redux/slices/placements/placementsSlice";
import { useDispatch } from "react-redux";
import axiosRequest from "../../../../../../../redux/slices/universal/axiosService";
import { ENDPOINTS } from "../../../../../../../redux/apiConfig";

const TimesheetDefaulterNotifiers = ({
  setActiveTab,
  currentPlacement,
  handleBack,
  editData,
}) => {
  const isEditable = !!editData;
  const dispatch = useDispatch();
  const [fetchPerticularData, setFetchPerticularData] = useState(null);
  const { formData, errors, handleChange, validateAllFields } = useFormHandler(
    {
      enableTask: true,
      notifierEmails: [],
    },
    {
      // enableTask: { type: "toggle", required: true },
      //  notifierEmails: { type: "email", required: true, multiple: true },
    },
  );
  function parseEmails(input) {
    return input
      .split(",")
      .map((email) => email.trim())
      .filter((email) => email.length > 0);
  }

  const handleSave = () => {
    const isValid = validateAllFields();
    if (isValid) {
      const defaulterNotifiers = {
        enable: formData.enableTask,
        emails: formData.notifierEmails,
      };
      const submissionData = filterEmptyValues(defaulterNotifiers);
      const uiid = fetchPerticularData?.uiid ?? "";
      dispatch(
        addNewPlacementStart({
          uiid: uiid,
          rsd: submissionData,
          rsn: "clientPlacementTimesheetNotifier",
          payload: [
            {
              type: "SET",
              value: {
                timesheetDetails: {
                  defaulterNotifiers: {
                    ...submissionData,
                  },
                },
              },
            },
          ],
          onSuccess: async (payload) => {
            console.log("payload : ", payload);
            handleBack();
          },
        }),
      );
    } else {
      console.log("errors :", errors);
    }
  };
  useEffect(() => {
    const clientPlacementTimesheetNotifier =
      currentPlacement?.clientPlacementTimesheetNotifier;

    if (clientPlacementTimesheetNotifier) {
      handleChange("enableTask", clientPlacementTimesheetNotifier?.enable);
      const emails = clientPlacementTimesheetNotifier?.emails;
      handleChange("notifierEmails", emails);

      // Convert array to comma-separated string
      // handleChange("notifierEmails", clientPlacementTimesheetNotifier?.emails.join(", "));
    }
  }, [currentPlacement]);
  useEffect(() => {
    const fetchData = async () => {
      const uiid =
        currentPlacement?.uiid ??
        editData?.uiid ??
        currentPlacement?.data?.doc?.uiid ??
        "";
      if (!uiid) return;
      const filter = {
        uiid: { type: "NONE", value: uiid },
      };
      try {
        const response = await axiosRequest({
          method: "GET",
          url: ENDPOINTS.PLACEMENTS.GET_BY_UIID,
          params: {
            coll: "Placement",
            fil: JSON.stringify(filter),
            ret: "timesheetDetails.defaulterNotifiers uiid",
          },
        });
        const data = response?.data?.data;
        if (data) {
          setFetchPerticularData(data);
          handleChange(
            "enableTask",
            data?.timesheetDetails?.defaulterNotifiers?.enable,
          );
          handleChange(
            "notifierEmails",
            data?.timesheetDetails?.defaulterNotifiers?.emails || [],
          );
        }
      } catch (error) {
        setFetchPerticularData(null);
        console.error("Failed to fetch placement data:", error);
      }
    };

    fetchData();
  }, [currentPlacement, isEditable]);
  return (
    // <div className="px-8 py-4 border-[1px] border-neutrals-50 rounded-b min-h-[65vh] overflow-auto">
    <div className="px-8 py-4 border-[1px] border-neutrals-50 rounded-b overflow-auto">
      <div className="max-w-7xl grid-cols-3 grid gap-x-8 gap-y-6">
        <div className="col-span-3">
          {/* <FormFieldSet
            type="toggle"
            title={"Enable Task"}
            isChecked={formData?.enableTask}
            value={formData?.enableTask}
            onChange={() => handleChange("enableTask", !formData.enableTask)}
            error={errors.enableTask}
            size="sm"
          /> */}
        </div>
        <div className="col-span-3">
          <FormFieldSet
            type="email"
            // title={"Notifier Email(s):-(Please type and enter)"}
            title={
              <ToolTip
                size="sm"
                description={"Please type and enter"}
                color="primary"
              >
                <span className="mr-1">Notifier Email(s)</span>
              </ToolTip>
            }
            placeholder="Enter Email(s)"
            value={formData.notifierEmails}
            onChange={(value) => handleChange("notifierEmails", value)}
            error={errors.notifierEmails}
            multiple
          />
        </div>
      </div>
      <div className="flex gap-3 justify-end mt-6">
        <Button
          title={"Cancel"}
          variant="outlined"
          // onClick={() => handleCancel()}
        />
        <Button title={"Save"} onClick={() => handleSave()} />
      </div>
    </div>
  );
};

export default TimesheetDefaulterNotifiers;
